import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IErrorData from "../../../core/src/server/data/errorData";

export default class ErrorDataParser implements IBaseDataParser<IErrorData> {
    public check(data: any): boolean {
        return data?.errorCode;
    }

    public parse(data: any): IErrorData[] {

       const result: IErrorData = {
            errorCode: data?.errorCode,
            errorMessage: data?.errorMessage,
            critical: true,
            rawError: data
       }

       return [result];
    }

}